// extracted by mini-css-extract-plugin
export var aiStarIcon = "_t5-2";
export var container = "_t5-4";
export var dismissButton = "_t5-3";
export var hasPaddingBottom = "_t5-6";
export var last = "_t5-e";
export var scrollbarThumb = "_t5-c";
export var scrollbarTrack = "_t5-b";
export var selected = "_t5-9";
export var spin = "_t5-1";
export var spinning = "_t5-0";
export var suggestionItem = "_t5-d";
export var suggestionsPanel = "_t5-5";
export var tonePill = "_t5-8";
export var tonesContainer = "_t5-7";
export var unselected = "_t5-a";